import React from 'react';
import { Navigate } from 'react-router-dom';
import { resolvePostLoginPath } from './decodedAdmin';

const HomeGate: React.FC = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <Navigate to={resolvePostLoginPath(token)} replace />;
};

export default HomeGate;
